import { atom } from 'recoil';
import { ATOM_KEYS } from 'utils/const/recoilKeys';
// Types
import { Winner } from 'types/lottery/winner';

export const fifthWinnersState = atom<Winner[]>({
  key: ATOM_KEYS.FIFTH_WINNERS_STATE,
  default: [],
});
